import { render } from "./LongtermDownload.vue?vue&type=template&id=e6d70648"
import script from "./LongtermDownload.vue?vue&type=script&lang=js"
export * from "./LongtermDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__